import styled from 'styled-components'
import { breakpoints } from 'src/utils/styles/global-styles'
import { Link } from 'gatsby'
import { darken, lighten } from 'polished'

export const ProductContainer = styled.div`
  background-color: ${(props) => (props.sunshine ? props.theme.sunshine : '#fff7e6')};
  padding: 72px 0px;
  margin-bottom: ${(props) => (props.sunshine ? '0px' : '40px')};
  @media (max-width: ${breakpoints.l}px) {
    margin: ${(props) => (props.sunshine ? '0px auto -40px' : '0px auto 24px')};
    padding: 40px 0px 56px;
  }
  @media (max-width: ${breakpoints.s}px) {
    margin: ${(props) => (props.sunshine ? '20px auto -20px' : '0px auto 16px')};
    padding: 16px 0px 24px;
  }
`

export const Container = styled.div`
  width: 90%;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  @media (max-width: ${breakpoints.s}px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`
export const Frame2Container = styled(Container)`
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  justify-content: flex-start;
  background-color: ${(props) => (props.sunshine ? props.theme.sunshine : '#fff7e6')};
  @media (max-width: ${breakpoints.l}px) {
    grid-template-columns: 1fr;
    gap: 0px;
    margin-top: 32px;
  }
`

export const CalMaxContainer = styled(Container)`
  grid-template-columns: 1fr 2fr;
  gap: 60px;
  justify-content: center;
  img {
    max-width: 100%;
    border-radius: 16px;
  }
  margin-bottom: 60px;
  @media (max-width: 1450px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;
  }
  @media (max-width: ${breakpoints.l}px) {
    grid-template-columns: 1fr;
    gap: 20px;
    margin-top: 16px;
    margin-bottom: 24px;
    div {
      order: 2;
    }
    > div:first-child {
      order: 2;
    }
    > div:last-child {
      order: 1;
    }
  }
  @media (max-width: ${breakpoints.s}px) {
    gap: 0px;
  }
`
export const MaxContainer = styled(CalMaxContainer)`
  margin-top: 56px;
  margin-bottom: 32px;
  @media (max-width: ${breakpoints.m}px) {
    margin-top: 32px;
  }
`

export const Heading = styled.h2`
  font-size: 28px;
  line-height: 110%;
  margin: 16px 0px;
  text-align: center;
  padding-top: ${(props) => (props.padding ? '16px' : '0px')};
  @media (max-width: ${breakpoints.l}px) {
    margin: 24px 0px 16px;
    padding-top: ${(props) => (props.padding ? '18px' : '0px')};
  }
  @media (max-width: 400px) {
    font-size: 24px;
  }
  @media (max-width: 350px) {
    font-size: 21px;
  }
`
export const Description = styled.p`
  font-size: 16px;
  margin: 0px auto;
  line-height: 110%;
  color: ${(props) => props.theme.grayDark};
  @media (max-width: ${breakpoints.l}px) {
    margin: 0px auto 8px;
  }
  @media (max-width: ${breakpoints.s}px) {
    font-size: 16px;
    margin: 0px auto;
    line-height: 24px;
  }
`

export const Card = styled.div`
  background-color: ${(props) => props.theme.blueLight};
  border-radius: 16px;
  padding: 16px;
  height: 100%;
`

export const CtaContainer = styled.div`
  padding: 30px 0px 20px;
  text-align: center;
  a {
    text-decoration: none;
  }
  @media (max-width: ${breakpoints.l}px) {
    padding: 16px 0px 20px;
  }

  @media (max-width: ${breakpoints.s}px) {
    width: 100%;
    a {
      width: 100%;
      display: block;
      text-align: center;
    }
  }
`
export const LogoContainer = styled.div`
  img {
    border-radius: 25px;
  }
`
export const TextContainer = styled.div`
  text-align: center;
`
export const CardLink = styled(Link)`
  text-decoration: none;
  margin-bottom: 0px;
  width: 100%;
  @media (max-width: ${breakpoints.l}px) {
    margin-bottom: 40px;
  }
  @media (max-width: ${breakpoints.m}px) {
    margin: auto;
  }
  @media (max-width: ${breakpoints.s}px) {
    max-width: 100%;
  }
`
export const BuyNowLinkCTA = styled.div`
  font-family: 'MatterRegular';
  background-color: ${(props) => props.theme.coral};
  color: white;
  text-decoration: none;
  border-radius: 28px;
  border: none;
  font-size: 18px;
  padding: 15px 30px;
  letter-spacing: 0.09px;
  display: inline;
  &:hover {
    cursor: pointer;
    background-color: ${(props) => darken(0.1, props.theme.coral)};
  }
  &:focus {
    outline: none;
    box-shadow: ${(props) => `0 0 0 0.2rem ${lighten(0.1, props.theme.coral)}`};
  }
  @media (max-width: ${breakpoints.m}px) {
    font-size: 16px;
    letter-spacing: 0.08px;
  }
  @media (max-width: ${breakpoints.s}px) {
    width: 100%;
    display: block;
    text-align: center;
  }
`
export const CalMaxHeroVideo = styled.video`
  width: 100%;
`

export const PressContainer = styled.div`
  padding: 0px;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  #time {
    width: 100px;
  }
  #verge {
    width: 180px;
  }
  #gma {
    width: 120px;
  }
  @media (max-width: ${breakpoints.l}px) {
    margin: -20px 0px 0px;
    #time {
      width: 70px;
    }
    #verge {
      width: 120px;
    }
    #gma {
      width: 90px;
    }
    flex-wrap: wrap;
  }
  @media (max-width: 540px) {
    margin: 0px 0px 30px;
    #time {
      width: 80px;
    }
    #verge {
      width: 180px;
    }
    #gma {
      width: 80px;
    }
  }
  @media (max-width: 540px) {
    max-width: 300px;
    margin: 0px auto 30px;
  }
`

export const PressIcon = styled.div`
  width: 80px;
  margin: 10px 20px;
  cursor: pointer;
  img {
    border-radius: 16px;
  }
  @media (max-width: ${breakpoints.s}px) {
    margin: 10px 10px 0px;
    width: 60px;
  }
  @media (max-width: 375px) {
    width: 50px;
  }
`

export const Flexbox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: 630px;
  margin: auto;
`
export const HideOnDesktop = styled.div`
  display: none;
  @media (max-width: ${breakpoints.l}px) {
    display: block;
  }
`
export const HideOnMobile = styled.div`
  display: block;
  @media (max-width: ${breakpoints.l}px) {
    display: none;
  }
`
export const ImageContainer = styled.div`
  position: relative;
`
